import { useForm } from "@mantine/form";
import moment from "moment";
import { Group, Text, Card } from "@mantine/core";

const AIRequestLogMessages = ({ form, name }) => {
  const aiRequest = form.values;
  const messages = (aiRequest.messages || [])
    .slice()
    .sort((a, b) => new Date(b.at) - new Date(a.at));
  return (
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        paddingRight: "8px",
      }}
    >
      {messages.map((message) => (
        <Card key={message.id} withBorder mt="md">
          <Text size="xs" color="dimmed">
            {moment(message.at).format("YYYY-MM-DD HH:mm:ss")}
          </Text>
          <Text size="xs">{message.content}</Text>
        </Card>
      ))}
    </div>
  );
};

export default AIRequestLogMessages;
